module.exports = __webpack_public_path__ + "fonts/CooperBlack.74355f72.woff2";